import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import Notifications from 'vue-notification';
import VueCookies from 'vue-cookies';
import App from './App.vue';
import router from './router';
import vuetify from './plugins/vuetify';
import store from './store';
import i18n from './i18n';

Vue.use(VueCookies);
Vue.$cookies.config('7d');
Vue.use(VueAxios, axios);

Vue.config.productionTip = false;

Vue.use(Notifications);
export default new Vue({
  router,
  vuetify,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
